import { render, staticRenderFns } from "./CalendarEvent.vue?vue&type=template&id=a1a34b4e&scoped=true&"
import script from "./CalendarEvent.vue?vue&type=script&lang=js&"
export * from "./CalendarEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a34b4e",
  null
  
)

export default component.exports